import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";
import { getLiterals } from "../../../../api/literal";
import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { alertError } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";

function getData(literals) {
  let data = [];
  for (let i = 0; i < literals.length; ++i) {
    const elem = {};
    elem.nombre = literals[i].nombre || "";
    elem.createdAt = literals[i].createdAt;
    elem.updatedAt = literals[i].updatedAt;
    elem.id = literals[i]._id;
    data = data.concat(elem);
  }
  return data;
}

export default function LiteralsPage() {
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();

  function buttonFormatter(cell) {
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-literal/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "nombre", text: "Nombre", sort: true },
    {
      dataField: "createdAt",
      text: "Created at",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "updatedAt",
      text: "Updated at",
      formatter: dateFormatter,
      sort: true,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getLiterals()
      .then((res) => {
        if (res.status === 200) {
          setData(getData(res.data.filter((literal) => !literal.ocultar)));
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get literals." });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Literales"></CardHeader>
        <CardBody>
          <Table data={data} columns={columns} />
        </CardBody>
      </Card>
    </>
  );
}
